import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { IconShapeArrowDown } from '@xingternal/malt-icon';
import { FormattedMessage } from 'react-intl';

import Modal, { ModalContainer, ModalContent } from '@xingternal/malt-modal';

import { DropdownItems } from './';
import styles from './ExtendedSearchDropdown.css';

class ExtendedSearchDropdown extends Component {
  state = { isOpened: false };

  static propTypes = {
    searchLink: PropTypes.func,
    searchTerm: PropTypes.string,
  };

  handleSubmit = type => {
    this.close();

    window.location.assign(
      this.props.searchLink({
        section: type,
        query: this.props.searchTerm || '',
        trackingKey: 'advanced_search',
      })
    );
  };

  open = () => {
    this.setState({ isOpened: true });
  };

  close = () => {
    this.setState({ isOpened: false });
  };

  render() {
    return (
      <ModalContainer className={styles.element}>
        <button
          className={styles.button}
          onClick={this.state.isOpened ? this.close : this.open}
        >
          <div className={styles.buttonInner}>
            <FormattedMessage id="VERTICAL_NAVIGATION_HEADER_SEARCH_ADVANCED">
              {text => <span className={styles.buttonText}>{text}</span>}
            </FormattedMessage>

            <IconShapeArrowDown className={styles.arrow} />
          </div>
        </button>
        {this.state.isOpened && (
          <Modal className={styles.ddModal} left onOutsideClick={this.close}>
            <ModalContent>
              <DropdownItems trigger={this.handleSubmit} />
            </ModalContent>
          </Modal>
        )}
      </ModalContainer>
    );
  }
}

export default ExtendedSearchDropdown;
